import {
	EditSquareFilledIcon,
	EditSquareIcon,
	GovBuildingFilledIcon,
	GovBuildingIcon,
	HomeFilledIcon,
	HomeIcon,
	SpeakerFilledIcon,
	SpeakerIcon,
} from '@change/ds-icons';

import { NavBadge } from './components/NavBadge';

export const NAVIGATION_ITEMS = [
	{
		selectedIcon: <HomeFilledIcon size="small" />,
		icon: <HomeIcon size="small" />,
		id: 'home',
		desktopLabel: 'Home',
		mobileLabel: 'Home',
		ariaLabel: 'Navigate to Home',
		section: 'home',
		dataQa: 'home-tab',
	},
	{
		selectedIcon: <SpeakerFilledIcon size="small" />,
		icon: <SpeakerIcon size="small" />,
		id: 'share',
		desktopLabel: 'Share petition',
		mobileLabel: 'Sharing tools',
		ariaLabel: 'Navigate to Share your petition',
		section: 'share',
		badge: <NavBadge label="New" />,
		dataQa: 'share-tab',
	},
	{
		selectedIcon: <GovBuildingFilledIcon size="small" />,
		icon: <GovBuildingIcon size="small" />,
		id: 'decision-maker',
		desktopLabel: 'Contact decision makers',
		mobileLabel: 'Decision maker',
		ariaLabel: 'Navigate to Connect to decision makers',
		section: 'decision-maker',
		dataQa: 'dm-tab',
	},
	{
		selectedIcon: <EditSquareFilledIcon size="small" />,
		icon: <EditSquareIcon size="small" />,
		id: 'updates',
		desktopLabel: 'Post an update',
		mobileLabel: 'Post update',
		ariaLabel: 'Navigate to Message your supporters',
		section: 'updates',
		dataQa: 'update-tab',
	},
];
